import {
  CMSApiBase,
  CMSDescription,
  CMSFaq,
  CMSGroupParams,
  CMSHowToParticipate,
  CMSImageBase,
  createCmsUrl,
} from './base';
import { fetcherCMS } from '@/modules/api';
import { getCMSLocale } from '@/modules/cms';

export interface ScratchGameMenuDataApi extends CMSApiBase {
  menu: {
    bg: CMSImageBase;
    character: CMSImageBase;
  };
}

export const getScratchGameMenuCMSUrl = (lang: string) =>
  createCmsUrl({
    path: 'scratch-game',
    queryData: {
      ...getCMSLocale(lang),
      populate: {
        menu: {
          populate: {
            bg: true,
            character: true,
          },
        },
      },
    },
  });

export const getScratchGameCMSUrl = (lang: string) =>
  createCmsUrl({
    path: 'scratch-game',
    queryData: { populate: 'deep', ...getCMSLocale(lang) },
  });

export const getScratchGamePageTitleCMSUrl = (lang: string) =>
  createCmsUrl({
    path: 'scratch-game',
    queryData: {
      ...getCMSLocale(lang),
      fields: ['page_title'],
    },
  });

export const fetchScratchGameMenuCMS = async (lang: string) => {
  const response = await fetcherCMS<ScratchGameMenuDataApi>(
    getScratchGameMenuCMSUrl(lang)
  );
  return { data: response };
};

export interface LockedCardDescription extends CMSGroupParams {
  cardDescription: string;
}

export interface ScratchGameApi extends CMSApiBase {
  pageTitle: string;
  pageDescription: CMSDescription[];
  leftImg: CMSImageBase;
  rightImg: CMSImageBase;
  mobImg: CMSImageBase;
  leftDecorImg: CMSImageBase;
  rightDecorImg: CMSImageBase;
  promoCode: string;
  topBg: CMSImageBase;
  lockedCardTitle: string;
  lockedCardDescription: LockedCardDescription[];
  howToParticipateTitle: string;
  howToParticipate: CMSHowToParticipate[];
  faqTitle: string;
  faq: CMSFaq[];
  fivePlusDepCardTitle: string;
  fivePlusDepCardDescription: string;
}

export const fetchScratchGameCMS = async (lang: string) => {
  const response = await fetcherCMS<ScratchGameApi>(getScratchGameCMSUrl(lang));
  return { data: response };
};

export interface ScratchGamePageTitleApi extends CMSApiBase {
  pageTitle: string;
}

export const fetchScratchGamePageTitleCMS = async (lang: string) => {
  const response = await fetcherCMS<ScratchGamePageTitleApi>(
    getScratchGamePageTitleCMSUrl(lang)
  );
  return { data: response };
};
